export default __webpack_public_path__ + "atomic/_patterns/02-molecules/page-title/_page-title.twig";